import React from 'react';
import QuoteForm from '../js/QuoteForm';
import './QuotePage.css';

export default function QuotePage() {
  return (
    <div className="quote-page">
      <QuoteForm />
    </div>
  );
}
